const TOKEN_KEY = 'jwtToken';
const USER_KEY  = 'userInfo';
const MF_KEY  = 'mfInfo';

const initialUser = (() => {
  try { return JSON.parse(localStorage.getItem(USER_KEY) || 'null'); }
  catch { return null; }
})();

const initialMf = (() => {
  try { return JSON.parse(localStorage.getItem(MF_KEY) || 'null'); }
  catch { return null; }
})();

const initialToken = localStorage.getItem(TOKEN_KEY) || null;

const state = {
  userInfo: initialUser,
  jwtToken: initialToken,
  mfInfo: initialMf,
};

const mutations = {
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
    localStorage.setItem(USER_KEY, JSON.stringify(userInfo || {}));
  },
  patchUserInfo(state, patch) {
    state.userInfo = { ...(state.userInfo || {}), ...(patch || {}) };
    localStorage.setItem(USER_KEY, JSON.stringify(state.userInfo));
  },
  setUserImage(state, imageUrl) {
    state.userInfo = { ...(state.userInfo || {}), imageUrl };
    localStorage.setItem(USER_KEY, JSON.stringify(state.userInfo));
  },
  setJwtToken(state, token) {
    state.jwtToken = token;
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  },
  clearAuth(state) {
    state.userInfo = null;
    state.jwtToken = null;
    state.mfInfo = null;
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(MF_KEY);
  },
  setMfInfo(state, mfInfo) {
    state.mfInfo = mfInfo;
    localStorage.setItem(MF_KEY, JSON.stringify(mfInfo || {}));
  },
  patchMfInfo(state, patch) {
    state.mfInfo = { ...(state.mfInfo || {}), ...(patch || {}) };
    localStorage.setItem(MF_KEY, JSON.stringify(state.mfInfo));
  },
};

const actions = {

  updateUserInfo({ commit }, partial) {
    commit('patchUserInfo', partial);
  },

  updateMfInfo({ commit }, partial) {
    commit('patchMfInfo', partial);
  },

  // 로그인 성공 시
  loginSuccess({ commit }, { userInfo, token, mfInfo }) {
    commit('setUserInfo', userInfo || null);
    commit('setJwtToken', token || null);
    commit('setMfInfo', mfInfo || null);
  },

  // 토큰만 갱신
  refreshToken({ commit }, token) {
    commit('setJwtToken', token || null);
  },

  // 로그아웃
  logout({ commit }) {
    commit('clearAuth');
  },
};

const getters = {
  isAuthenticated: (state) => !!state.jwtToken,
  getUserInfo:     (state) => state.userInfo,
  getMfInfo:     (state) => state.mfInfo,
  getMfId:         (state) => state.mfInfo?.companyPrefix || null,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
